import { Component } from "@angular/core"
import {  FormBuilder,  FormGroup, Validators } from "@angular/forms"
import  { Router } from "@angular/router"
// import type { AuthService } from "../../services/auth.service"
@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent {
  createAccountForm: FormGroup
  isTeacher = false
  isLoading = false
  error: string | null = null

  constructor(
    private fb: FormBuilder,
    // private authService: AuthService,
    private router: Router,
  ) {
    this.createAccountForm = this.fb.group({
      fullName: ["", Validators.required],
      id: ["", Validators.required],
      schoolPasskey: ["", Validators.required],
      contactNumber: ["", [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6)]],
      // Professional Details (only for teachers)
      gradeLevels: [""],
      subjects: [""],
      classTutor: [""],
    })
  }

  toggleRole(isTeacher: boolean) {
    this.isTeacher = isTeacher
    if (isTeacher) {
      this.createAccountForm.get("gradeLevels")?.setValidators(Validators.required)
      this.createAccountForm.get("subjects")?.setValidators(Validators.required)
    } else {
      this.createAccountForm.get("gradeLevels")?.clearValidators()
      this.createAccountForm.get("subjects")?.clearValidators()
    }
    this.createAccountForm.get("gradeLevels")?.updateValueAndValidity()
    this.createAccountForm.get("subjects")?.updateValueAndValidity()
  }

  onSubmit() {
    if (this.createAccountForm.valid) {
      this.isLoading = true
      this.error = null

      const formData = {
        ...this.createAccountForm.value,
        role: this.isTeacher ? "teacher" : "student",
      }

      // this.authService.createAccount(formData).subscribe({
      //   next: () => {
      //     this.router.navigate(["/login"])
      //   },
      //   error: (err) => {
      //     this.error = err.message || "An error occurred during account creation"
      //     this.isLoading = false
      //   },
      //   complete: () => {
      //     this.isLoading = false
      //   },
      // })
    }
  }
}
